
<template>
  <div>
    <el-dialog :title="projectName" width="900px" :visible.sync="dialogFormVisible">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="工程详情" name="first">
          <div style="width:100%;margin-top:15px;height:600px;overflow:auto;">
            <el-card class="box-card" style="margin-bottom:15px;">
              <el-row style="margin:0 15px;">
                <el-col :span="24">
                  <el-col :span="8">
                    <span style="margin-bottom: 8px;">项目单号 : {{projectId}}</span>
                  </el-col>
                  <el-col :span="8">
                    <p style="margin-bottom: 8px;">发布人 : {{userName}}</p>
                  </el-col>
                  <el-col :span="8">
                    <p style="margin-bottom: 8px;">发布时间 : {{createTime}}</p>
                  </el-col>
                </el-col>
                <el-col :span="24">
                  <el-col :span="8">
                    <p style="margin-bottom: 8px;">开工时间 : {{startTime}}</p>
                  </el-col>
                  <el-col :span="8">
                    <p style="margin-bottom: 8px;">工作时长 : {{duration}}天</p>
                  </el-col>
                  <el-col :span="8">
                    <p style="margin-bottom: 8px;">是否加班 : {{isOvertime == 0?'不加班':'加班'}}</p>
                  </el-col>
                </el-col>
                <el-col :span="24">
                  <img v-if="state == -2" src="../developed/xmqx.png" class="projectimg">
                  <img v-else-if="state == -1" src="../developed/wfb.png" class="projectimg">
                  <img v-else-if="state == 0" src="../developed/zzzm.png" class="projectimg">
                  <img v-else-if="state == 1" src="../developed/zzzx.png" class="projectimg">
                  <img v-else-if="state == 2" src="../developed/xmqx.png" class="projectimg">
                  <img v-else-if="state == 3" src="../developed/xmcs.png" class="projectimg">
                  <img v-else-if="state == 4" src="../developed/zzzx.png" class="projectimg">
                  <img v-else-if="state == 5" src="../developed/ddjx.png" class="projectimg">
                  <img v-else-if="state == 6" src="../developed/jjjx.png" class="projectimg">
                  <img v-else src="../developed/xmwj.png" class="projectimg">
                </el-col>
              </el-row>
            </el-card>
            <el-card class="box-card" style="margin-bottom:15px;">
              <div v-for="(item,index) in address" :key="index" class="text item">
                <div style="margin-bottom:8px;">
                  <p
                    style="margin-left: 15px;margin-bottom: 8px;"
                  >
                    工程地址{{index+1}} : {{item.address}}
                  </p>
                  <el-row style="margin:0 15px;">
                    <el-col :span="8">
                      <p style="margin-bottom: 8px;">门牌号 : {{item.houseNum}}</p>
                    </el-col>
                    <el-col :span="8">
                      <p style="margin-bottom: 8px;">联系人 : {{item.contacts}}</p>
                    </el-col>
                    <el-col :span="8">
                      <p style="margin-bottom: 8px;">联系电话 : {{item.contactPhone}}</p>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-bottom:15px;">
              <el-col :span="3">
                <p style="margin-left: 15px;margin-bottom: 8px;">需求师傅</p>
              </el-col>
              <el-col :span="21">
                <div v-for="(item,index) in workTypes" :key="index" style="float:left;">
                  <div style="margin-bottom:8px;">
                    <el-tag style="margin-right:10px;">{{item.workTypeName}}{{item.needNum}}人</el-tag>
                  </div>
                </div>
              </el-col>
            </el-card>
            <el-card class="box-card" style="margin-bottom:15px;">
              <el-col :span="3">
                <p style="margin-left: 15px;margin-bottom: 8px;">需求工具</p>
              </el-col>
              <el-col :span="21">
                <div v-for="(item,index) in needTools" :key="index" style="float:left;">
                  <div style="margin-bottom:8px;">
                    <el-tag style="margin-right:10px;">{{item.name}}</el-tag>
                  </div>
                </div>
              </el-col>
            </el-card>
            <el-card class="box-card" style="margin-bottom:15px;">
              <el-col :span="3">
                <p style="margin-left: 15px;margin-bottom: 8px;">工作内容</p>
              </el-col>
              <el-col :span="21">
                <div
                  v-for="(domain,index) in domains"
                  :key="index"
                  style="color:#606266;font-size:16px;cursor:pointer;"
                >
                  <el-col :span="18">
                    <span
                      class="textOverflow"
                      @click="openContentInfo(domain)"
                    >{{index+1}} 、{{domain.tips}}</span>
                  </el-col>
                  <el-col :span="2">
                    <i class="el-icon-picture">{{domain.imgCount}}</i>
                  </el-col>
                  <el-col :span="2">
                    <i class="el-icon-video-camera">{{domain.voiceCount}}</i>
                  </el-col>
                  <el-col :span="2">
                    <i class="el-icon-close" @click="deletetask(index)"></i>
                  </el-col>
                </div>
              </el-col>
            </el-card>
            <el-card class="box-card" style="margin-bottom:15px;">
              <el-col :span="3">
                <p style="margin-left: 15px;margin-bottom: 8px;">项目附件</p>
              </el-col>
              <el-col :span="21">
                <div v-for="(item,index) in filePaths" :key="index">
                  <a
                    :href="item.url|getBaseImgUrl"
                    target="view_window"
                    :download="item.name"
                  >{{item.name}}</a>
                </div>
              </el-col>
            </el-card>
            <contentInfo ref="contentInfo"></contentInfo>
            <el-card class="box-card" style="margin-bottom:15px;" v-if="getReports.length>0">
              <el-col :span="3">
                <p style="margin-left: 15px;margin-bottom: 8px;">验收报告</p>
              </el-col>
              <el-col :span="21">
                <div
                  v-for="(item,index) in getReports"
                  :key="index"
                  style="width:80px;float:left;margin-right:15px;"
                >
                  <img
                    :src="getimgpath(item)"
                    style="width:80px;height:80px;"
                    @click="showysbg(getimgpath(item))"
                  >
                </div>
              </el-col>
            </el-card>

            <el-card class="box-card" style="margin-bottom:15px;" v-if="stakeholders">
              <el-col :span="3">
                <p style="margin-left: 15px;margin-bottom: 8px;">项目相关人</p>
              </el-col>
              <el-col :span="21">
                <div
                  v-for="(item,index) in stakeholders"
                  :key="index"
                  style="width:80px;float:left;margin-right:15px;"
                >
                  <img
                    :src="item.avatar?getimgpath(item.avatar):(item.headimgurl?item.headimgurl:'/img/default-avatar.png')"
                    style="width:60px;height:60px;border-radius: 50%;"
                  >
                  <el-tag>{{item.userName}}</el-tag>
                </div>
                <el-button
                  @click="addProjectPeople"
                  size="mini"
                  icon="el-icon-edit"
                  type="primary"
                  style="float: right;margin-right: 15px;"
                >修改</el-button>
              </el-col>
            </el-card>
            <!--项目相关人-->
            <el-dialog title="项目相关人" :visible.sync="projectManVisible" append-to-body>
                <div style="width:100%;margin-left:20px;margin-bottom: 20px;">
                    <el-tag
                    v-for="tag in tags"
                    :key="tag.name"
                    closable
                    :disable-transitions="true"
                    @close="handleClose(tag)"
                    :type="tag.type"
                    class="tag"
                    >{{tag.name}}</el-tag>
                </div>
              <avue-crud
                ref="userCrud"
                :data="comworkerData"
                :option="stakeholderOption"
                @refresh-change="searchChange"
                @search-change="searchChange"
                @selection-change="selectionChange"
              >
                <template slot="search">
                  <el-form-item label="关键字">
                    <el-input v-model="search.condition"></el-input>
                  </el-form-item>
                </template>
              </avue-crud>
              <div slot="footer" class="dialog-footer">
                <el-button @click="chooseTrue">确定</el-button>
                <el-button @click="projectManVisible = false">关闭</el-button>
              </div>
            </el-dialog>
            <el-card class="box-card" style="margin-bottom:15px;">
              <el-col :span="3">
                <p style="margin-left: 15px;margin-bottom: 8px;">发布渠道</p>
              </el-col>
              <el-col :span="21">
                <div
                  v-if="isOpen==1"
                  style="text-align:center;width:70px;float:left;margin-right:15px;margin-bottom:15px;"
                >
                  <img src="/img/open.png" style="width:60px;height:60px;border-radius: 50%;">
                  <el-tag>需求大厅</el-tag>
                </div>
                <div
                  v-for="(item,index) in inviteGroups"
                  :key="index"
                  style="text-align:center;width:60px;float:left;margin-right:15px;margin-bottom:15px;"
                >
                  <img src="/img/group.png" style="width:60px;height:60px;border-radius: 50%;">
                  <el-tag>{{item.name}}</el-tag>
                </div>
                <div
                  v-for="(item,index) in inviteWorkers"
                  :key="index"
                  style="text-align:center;width:60px;float:left;margin-right:15px;margin-bottom:15px;"
                >
                  <img
                    :src="item.avatar?getimgpath(item.avatar):item.headimgurl"
                    style="width:60px;height:60px;border-radius: 50%;"
                  >
                  <el-tag>{{item.userName}}</el-tag>
                </div>
              </el-col>
            </el-card>
            <el-card class="box-card" style="margin-bottom:15px;">
              <el-col :span="3">
                <p style="margin-left: 15px;margin-bottom: 8px;">应招师傅</p>
              </el-col>
              <el-col :span="21">
                <div v-if="works.length>0">
                  <div
                    v-for="(item,index) in works"
                    :key="index"
                    style="width:60px;float:left;margin-right:15px;margin-bottom:15px;text-align:center;"
                  >
                    <img
                      :src="item.avatar?getimgpath(item.avatar):item.headimgurl"
                      style="width:60px;height:60px;border-radius: 50%;"
                    >
                    <el-tag>{{item.name}}</el-tag>
                  </div>
                </div>
                <div v-else style="text-align: left;font-size: 17px;">
                  <span>暂无应招师傅。</span>
                </div>
              </el-col>
            </el-card>
            <el-card class="box-card" style="margin-bottom:15px;" v-if="refuse.length>0">
              <el-col :span="3">
                <p style="margin-left: 15px;margin-bottom: 8px;">取消原因</p>
              </el-col>
              <el-col :span="21">
                <div v-for="(item,index) in refuse" :key="index" class="text item">
                  <div style="margin-bottom:8px;">
                    <p
                      style="margin-left: 15px;margin-bottom: 8px;"
                    >取消原因{{index+1}} : {{item.content}}</p>
                    <el-row style="margin:0 15px;">
                      <el-col :span="8">
                        <p style="margin-bottom: 8px;">取消人 : {{item.userName?item.userName:'系统操作'}}</p>
                      </el-col>
                      <el-col :span="8">
                        <p style="margin-bottom: 8px;">联系人方式 : {{item.phone}}</p>
                      </el-col>
                      <el-col :span="8">
                        <p style="margin-bottom: 8px;">取消时间 : {{settime(item.createTime)}}</p>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-col>
            </el-card>
          </div>
        </el-tab-pane>
        <el-tab-pane label="进度详情" name="second">
          <el-row v-if="prolist.length==0" style="text-align: center;font-size: 20px;">
            <span>暂时没有记录!</span>
          </el-row>
          <el-row v-for="(item,index) in prolist" :key="index">
            <el-col :span="5" style="text-align: center;">
              <img
                :src="item.avatar?getimgpath(item.avatar):item.headimgurl?item.headimgurl:'/img/default-avatar.png'"
                style="width:60px;border-radius:50%;"
              >
            </el-col>
            <el-col
              :span="5"
              style="line-height: 60px;font-size: 17px;"
            >{{item.userName?item.userName:'系统操作'}}</el-col>
            <el-col :span="5" style="line-height: 60px;font-size: 17px;">{{item.typeName}}</el-col>
            <el-col
              :span="9"
              style="line-height: 60px;font-size: 17px;"
            >{{settime(item.createTime)}}</el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="项目反馈" name="three">
          <avue-crud :data="record" width="70%" :option="tableOption" @row-click="showRow">
            <template slot-scope="scope" slot="menuLeft">
              <el-button
                style="margin-left:15px;"
                @click="showcomment"
                :disabled="recordStatus"
                size="mini"
                icon="el-icon-view"
                type="primary"
              >查看详情</el-button>
            </template>
            <template slot-scope="scope" slot="id">
              <el-radio class="radio" v-model="radiorecord" :label="scope.row.id"></el-radio>
            </template>
          </avue-crud>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="addrecord"
          v-if="state == 0 || state == 1 || state == 4 ||state == 5 ||state == 6"
          size="mini"
          icon="el-icon-edit-outline"
          type="primary"
        >添加反馈</el-button>
        <el-button
          @click="cancelProject"
          v-if="state==0"
          size="mini"
          icon="el-icon-close"
          type="primary"
        >取消项目</el-button>
        <el-button
          @click="againproject"
          size="mini"
          v-if="state==2 || state==-1"
          icon="el-icon-edit-outline"
          type="primary"
        >重新发布</el-button>
        <el-button
          @click="refusebtn"
          size="mini"
          v-if="state==5"
          icon="el-icon-remove"
          type="primary"
        >拒绝结项</el-button>
        <el-button
          @click="agreebtn"
          size="mini"
          v-if="state==5"
          icon="el-icon-circle-check"
          type="primary"
        >同意结项</el-button>
        <el-button
          @click="deleteProject"
          v-if="state==-2 || state==-1 || state==0 || state==2 || state==3"
          size="mini"
          icon="el-icon-delete"
          type="primary"
        >删除项目</el-button>
      </div>
    </el-dialog>
    <!--拒绝结项-->
    <refuse ref="child3" @refresh="refresh"></refuse>
    <!--添加反馈-->
    <insertrecord ref="childinsert" @refreshcord="refreshcord"></insertrecord>
    <!--展示结项图片-->
    <showReport ref="imgchild"></showReport>
    <!--查看视频-->
    <videolist ref="childvideo"></videolist>
    <!--查看反馈信息-->
    <comment ref="childcomment"></comment>
  </div>
</template>
<script>
import {
  getProjectInfo,
  closeProject,
  addObj,
  getReport,
  deletOrder,
  agree,
  getProgInfo,
  getFeedbacks
} from "@/api/admin/taskManagement";
import { getWorkerInfo, getdicts,updateStakeholders } from "@/api/admin/business";
import { personnelget1 } from "@/const/asset/user";
import { getImgLink } from "@/config/env";
import { mapGetters } from "vuex";
import { dateOnce } from "@/util/dateT";
import { objKeySort } from "@/util/ajaxsign";
import record from "./record.vue";
import refuse from "./refuse.vue";
import insertrecord from "./insertrecord.vue";
import showReport from "./showimg.vue";
import videolist from "./video.vue";
import comment from "./comment.vue";
import contentInfo from "./contentInfo.vue";

export default {
  components: {
    record,
    refuse,
    showReport,
    videolist,
    comment,
    insertrecord,
    contentInfo
  },
  data() {
    return {
      dialogFormVisible: false,
      projectManVisible: false,
      cancelStateus: true,
      statecancel: true,
      recordflag: false, //查看日志
      activeName: "first",
      tags:[],
      prolist: [],
      comworkerData: [],
      stakeholderOption: personnelget1,
      radiouser: "",
      index: "", //选中的地址下标
      getReports: [], //验收报告
      refuse: [],
      stakeholders: [], // 项目相关人
      filePaths: [], //项目附件
      isOpen: 0, //是否发布到需求大厅
      inviteWorkers: [], //发布渠道选择的师傅
      inviteGroups: [], //发布渠道选择的群组
      works: [], //参与师傅
      projectName: "",
      projectId: "", //项目id号
      orderinfo: "",
      address: "",
      startTime: "",
      duration: "",
      isOvertime: "",
      workTypes: [],
      needTools: [],
      domains: [],
      record: [],
      search: {},
      state: "",
      radiorecord: "",
      serviceType: "",
      recordStatus: "",
      companyName: "",
      userName: "",
      imgstate: "",
      workerData: [],
      page: {
        pageSizes: [10, 20, 50, 100],
        currentPage: 1,
        total: 0,
        pageSize: 10
      },
      createTime: "",
      tableOption: {
        addBtn: false,
        refreshBtn: false,
        columnBtn: true,
        editBtn: true,
        delBtn: true,
        menu: false,
        page: true,
        border: true,
        align: "center",
        menuAlign: "center",
        height: window.innerHeight - 290,
        serviceType: "",
        index: false,
        column: [
          {
            label: "",
            prop: "id",
            width: 40,
            solt: true
          },
          {
            label: "反馈人",
            prop: "userName"
          },
          {
            label: "问题是否解决",
            prop: "flag",
            formatter: function(row, value, label, column) {
              return row.flag == 1 ? "已解决" : "未解决";
            }
          },
          {
            label: "内容信息",
            prop: "tips",
            overHidden: true,
            formatter: function(row, value, label, column) {
              return row.tips.split("times")[0];
            }
          },
          {
            label: "查看(次)",
            prop: "viewNum"
          },
          {
            label: "评论(次)",
            prop: "commentNum"
          },
          {
            label: "创建时间",
            prop: "createTime",
            overHidden: true,
            type: "date",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          }
        ]
      }
    };
  },
  created() {},
  mounted() {  },
  filters: {
    getBaseImgUrl: function(uri) {
      console.log(uri);
      if (uri) {
        return getImgLink(uri);
      } else {
        return "";
      }
    }
  },
  methods: {
    // 项目相关人确定选择
    chooseTrue() {
      this.projectManVisible = false;
      console.log(this.tags);
      let stakeholderIds = '';
      if(this.tags&&this.tags.length>0){
          this.tags.forEach(tag =>{
              stakeholderIds = stakeholderIds+tag.id+',';
          });
          stakeholderIds = stakeholderIds.substring(0,stakeholderIds.length-1);
      }
        updateStakeholders(objKeySort({projectId:this.projectId,stakeholderIds:stakeholderIds})).then(response => {
            if(response&&response.data&&response.data.data&&response.data.code==200){
                this.stakeholders = response.data.data;
            }else{
                this.$message(response.data.msg);
            }

        })


    },

    getxmxgr() {
      this.comworkerData = [];
      this.search.companyId = this.companyId;
      this.search.pageNum = 1;
      this.search.pageSize = 999;
      getWorkerInfo(objKeySort(this.search)).then(response => {
        this.page.total = response.data.data.total;
        this.comworkerData = response.data.data.rows;
        response.data.data.rows.forEach(comworker => {
          if (this.userInfo.id == comworker.id) {
            comworker.name = comworker.name + "(自己)";
          }
          let flag = false;
          //debugger
          console.log(this.stakeholders);
          if (this.stakeholders.length > 0) {
            this.stakeholders.forEach(tag => {
              if (tag.userId == comworker.id) {
                flag = true;
              }
            });
          }
          if (flag){
              this.tags.push(comworker);
          }
        });
        console.log(this.tags);
        this.$nextTick(() => {
            this.tags.forEach(tag =>{
                this.$refs.userCrud.toggleRowSelection(tag,true);
            });
    })
      });
    },

    // 项目相关人关闭标签
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
      this.$refs.userCrud.toggleRowSelection(tag,false);
    },
    selectionChange(list) {
        console.log(list);
      this.tags = list;
    },
    //搜索数据
    searchChange(params) {
      if (!params.name) {
        params.name = "";
      }
      this.search.condition = params.condition;
      this.getxmxgr();
    },
    //搜索师傅信息
    searchChangegr(params) {
      this.searchgr = {
        condition: params.condition,
        groupId: params.groupNames,
        isForeman: params.isForeman,
        workTypeId: params.workTypeIds
      };
      getWorkerList(objKeySort(dealElement(this.searchgr))).then(response => {
        this.workerData = response.data.data;
        this.workerData.forEach(data => {
          data.workTypeIds = this.formatterWorkType(data.workTypeIds);
        });
      });
      console.log(this.searchgr);
    },
    // 新增项目相关负责人
    addProjectPeople() {
      this.projectManVisible = true;
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      this.companyId = this.userInfo.companyId;
      this.getxmxgr();
    },
    //刷新列表操作
    refresh() {
      this.getCompanyInfo(this.projectId);
    },

    refreshcord() {
      this.activeName = "three";
      this.getfeedback();
    },

    //设置展示
    setsataus(data, state, state1) {
      this.dialogFormVisible = true;
      this.cancelStateus = state;
      this.projectId = data;
      this.statecancel = state1 ? state1 : "";
      this.getReports = [];
      this.getCompanyInfo(data);
    },

    //详情展示
    handleClick(tab, event) {
      this.activeName = tab.name;
      if (tab.name == "second") {
        this.getProgInfo();
      } else if (tab.name == "three") {
        this.getfeedback();
      }
      // this.activeName = 'second';
    },

    openContentInfo(content) {
      this.$refs.contentInfo.setData(content);
    },

    //项目详情数据请求
    getCompanyInfo(data) {
      this.activeName = "first";
      getProjectInfo(objKeySort({ projectId: data })).then(response => {
        this.projectName = response.data.data.projectName;
        this.state = response.data.data.state;
        this.address = response.data.data.projectAddresses;
        this.startTime = this.settime(response.data.data.startTime);
        this.duration = response.data.data.duration;
        this.isOvertime = response.data.data.isOvertime;
        this.workTypes = JSON.parse(response.data.data.workTypes);
        this.needTools = JSON.parse(response.data.data.needTools);
        this.domains = response.data.data.workProjectContents;
       // debugger;
        if (this.domains && this.domains.length > 0) {
          this.domains.forEach(domain => {
            if (domain.voicePaths) {
              domain.voiceCount = domain.voicePaths.split(",").length;
            }
            if (domain.voicePaths) {
              domain.imgCount = domain.imgPaths.split(",").length;
            }
          });
        }
        if (data.imgPaths) {
          data.imgPaths.split(",").forEach(path => {
            this.contentInfo.imgPaths.push(path);
          });
        }
        if (data.voicePaths) {
          data.voicePaths.split(",").forEach(path => {
            this.contentInfo.voicePaths.push(path);
          });
        }
        if (this.contentInfo && this.contentInfo.imgPaths) {
          this.contentInfo.imgCount = this.contentInfo.imgPaths.length;
        }
        if (this.contentInfo && this.contentInfo.voicePaths) {
          this.contentInfo.voiceCount = this.contentInfo.voicePaths.length;
        }

        this.stakeholders =
          response.data.otherData.stakeholders
            ? response.data.otherData.stakeholders
            : [];
        this.filePaths = JSON.parse(response.data.data.filePaths);

        this.works = response.data.otherData.workers;
        this.refuse =
          response.data.otherData.cancelInfos != undefined
            ? response.data.otherData.cancelInfos
            : [];
        this.companyName = response.data.data.companyName;
        this.userName = response.data.data.userName;
        this.createTime = this.settime(response.data.data.createTime);
        this.isOpen = response.data.data.isOpen;
        if (response.data.otherData.inviteWorkers) {
          this.inviteWorkers = response.data.otherData.inviteWorkers;
        }
        if (response.data.otherData.inviteGroups) {
          this.inviteGroups = response.data.otherData.inviteGroups;
        }

        //处理展示验收报告
        if (
          Number(response.data.data.state) == 5 ||
          Number(response.data.data.state) == 6
        ) {
          this.getReport(response.data.data.projectId);
        }
      });
    },

    //默认时间
    settime(data) {
      return dateOnce(data);
    },

    //产看结项图片
    showysbg(data) {
      this.$refs.imgchild.imgstate(data);
    },

    //查看已招师傅信息
    recruitment() {
      this.$refs.workerchild.workerstate(this.works);
    },

    //查看日志
    journal() {
      this.$refs.recordchild.recordstate(this.projectId, this.state);
    },

    // 关闭项目
    handleStop() {
      this.dialogStop = true;
    },

    //拒绝时间
    refusetime(data) {
      return dateOnce(data);
    },
    //查看进度
    showprogress() {
      this.$refs.child2.setsataus(this.projectId);
    },
    //取消项目
    cancelProject() {
      this.$refs.child3.setsataus(this.projectId, "取消原因");
    },
    //重新发布项目
    againproject() {
      this.$router.push("/project/add");
      sessionStorage.setItem("projectId", this.projectId);
    },
    //拒绝结项
    refusebtn() {
      this.$refs.child3.setsataus(this.projectId, "拒绝原因");
    },
    //同意结项
    agreebtn() {
      agree(objKeySort({ projectId: this.projectId })).then(response => {
        this.$emit("refresh");
        this.getCompanyInfo(this.projectId);
      });
    },
    //获取结项图片
    getReport(data) {
      getReport(objKeySort({ projectId: data })).then(response => {
        this.getReports = response.data.data.imgPaths.split(",");
      });
    },
    //删除项目
    deleteProject() {
      deletOrder(objKeySort({ projectId: this.projectId })).then(response => {
        this.$emit("refresh");
        this.dialogFormVisible = false;
      });
    },
    //图片路径处理
    getimgpath(data) {
      return getImgLink(data);
    },
    //添加日志
    addrecord() {
      this.$refs.childinsert.setProjectId(this.projectId);
    },
    //查看进度详情
    getProgInfo() {
      getProgInfo(objKeySort({ projectId: this.projectId })).then(response => {
        this.prolist = response.data.data;
      });
    },
    getfeedback() {
      getFeedbacks(objKeySort({ projectId: this.projectId })).then(response => {
        this.record = response.data.data;
      });
    },
    //查看视频详情
    showVideo(data, type) {
      this.$refs.childvideo.viderstate(data, type);
    },
    //查看评论信息
    showcomment() {
      this.$refs.childcomment.commentstate(
        this.radiorecord,
        this.serviceType,
        this.state
      );
    },
    showRow(row) {
      this.radiorecord = row.id;
      this.serviceType = row.type;
      this.recordStatus = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.form_layout_items {
  display: flex;
}
.select_option {
  position: absolute;
  z-index: 22;
  width: 150px !important;
  right: 0;
  top: 0;
}
.el-table ::v-deep .el-table__row:nth-child(even) {
  background-color: #f6f9ff !important;
}
.form_layout_item {
  width: 50%;
  border: 1px solid #fff;
  height: 80px;
}
.projectimg {
  width: 130px;
  float: right;
  display: block;
  margin-top: -75px;
  margin-bottom: 10px;
}
.tag{
    margin-right:10px;
}
</style>
